import React from "react";

interface PaginationProps {
    page: number;
    total_pages: number;
    total_records: number;
    page_size: number;
    onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
    page,
    total_pages,
    total_records,
    page_size,
    onPageChange
}) => {

    // Function to generate page numbers with "..."
    const generatePages = () => {
        const pages: (number | string)[] = [];

        if (total_pages <= 7) {
            for (let i = 1; i <= total_pages; i++) pages.push(i);
            return pages;
        }

        pages.push(1);

        if (page > 3) pages.push("...");

        const start = Math.max(2, page - 1);
        const end = Math.min(total_pages - 1, page + 1);

        for (let i = start; i <= end; i++) pages.push(i);

        if (page < total_pages - 2) pages.push("...");

        pages.push(total_pages);

        return pages;
    };

    return (
        <div style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
        }}>
            <div
                style={{
                    marginBottom: "12px",
                    fontSize: "12px",
                    color: "#555",
                }}
            >
                <strong>
                    Total {Math.min(page * page_size, total_records)} of {total_records}{" "}
                    records found
                </strong>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {/* Prev Button */}
                <button
                    disabled={page <= 1}
                    onClick={() => onPageChange(page - 1)}
                    style={{
                        padding: "6px 14px",
                        cursor: page <= 1 ? "not-allowed" : "pointer",
                    }}
                >
                    Prev
                </button>

                {/* Number Buttons */}
                {generatePages().map((p, i) =>
                    p === "..." ? (
                        <span key={i} style={{ padding: "6px 10px" }}>...</span>
                    ) : (
                        <button
                            key={i}
                            onClick={() => onPageChange(p as number)}
                            style={{
                                padding: "6px 12px",
                                background: p === page ? "#3a4563" : "#fff",
                                color: p === page ? "#fff" : "#000",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }}
                        >
                            {p}
                        </button>
                    )
                )}

                {/* Next Button */}
                <button
                    disabled={page >= total_pages}
                    onClick={() => onPageChange(page + 1)}
                    style={{
                        padding: "6px 14px",
                        cursor: page >= total_pages ? "not-allowed" : "pointer",
                    }}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Pagination;
